import React from "react";
import { INDUSTRIES } from "@/constants/brand";

export const Industries = () => {
  const items = [...INDUSTRIES, ...INDUSTRIES];
  return (
    <section data-testid="industries-section" className="py-16 md:py-20 bg-[#FAFAFA] border-y border-[#E2E8F0] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex items-center justify-between flex-wrap gap-4 mb-8">
          <p className="uppercase text-xs tracking-[0.22em] font-bold text-[#0055FF]">
            Industries we serve
          </p>
          <p className="text-sm text-[#475569]">
            From shop floors in Pune to D2C brands in Bengaluru.
          </p>
        </div>
      </div>
      <div className="relative">
        <div className="ifx-marquee" data-testid="industries-marquee">
          {items.map((it, idx) => (
            <div
              key={`${it}-${idx}`}
              className="mx-8 md:mx-12 flex items-center gap-4 whitespace-nowrap"
            >
              <span className="h-2 w-2 rounded-full bg-[#0055FF]" />
              <span className="font-display text-3xl md:text-5xl font-bold tracking-tight text-[#0B1120]">
                {it}
              </span>
            </div>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 md:w-40 bg-gradient-to-r from-[#FAFAFA] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 md:w-40 bg-gradient-to-l from-[#FAFAFA] to-transparent" />
      </div>
    </section>
  );
};
